import {
    RECOMMENDED_RIDES_START,
    RECOMMENDED_RIDES_SUCCESS,
    RECOMMENDED_RIDES_ERROR
} from "Constant/RentalCustomer";
  
const initialState = {
    loading: false,
    ride_data: []
};
  
export default function headerDataReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case RECOMMENDED_RIDES_START:
        return {
          ...state,
          loading: true,
        };
      case RECOMMENDED_RIDES_SUCCESS:
        return {
          ...state,
          ride_data: action.payload,
          loading: false,
        };
      case RECOMMENDED_RIDES_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
}
  